import TargetApplicationTemplate from './ApplicationRouteTemplate';

export default TargetApplicationTemplate;
